var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('big-list-layout',{attrs:{"slice":_vm.sliceData,"table-data":_vm.getTableData}})}
var staticRenderFns = []

export { render, staticRenderFns }